import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Al infanterio <br/>
        Pardonu, se foje ĝin prenas desper’. <br/>
        Ni ĉiam foriras, <br/>
        Dum regas plenpove sur Ter’ primaver’,
      </p>

      <p class="poem-block mb-3">
        Ŝtupar’ malfortika, <br/>
        Ni iras laŭ ĝi sen apog’, laŭ hazard’, <br/>
        Nur blankaj salikoj <br/>
        Nin sekvas per longa fratina rigard’.
      </p>

      <p class="poem-block mb-3">
        Ne kredu klimaton, <br/>
        Se pluvas obstine kaj kotas la voj’. <br/>
        Ne kredu soldaton, <br/>
        Se brave li kantas kaj marŝas kun ĝoj’.
      </p>

      <p class="poem-block mb-3">
        Ne kredu vi trilon <br/>
        De ĥor’ najtingala printempa en kort’. <br/>
        Ne sentu jubilon, <br/>
        Ke pacas eterne jam vivo kaj mort’.
      </p>

      <p class="poem-block mb-3">
        Nin tempo instruis: <br/>
        Ne haltu survoje, ne fuĝu de l’ ag’. <br/>
        La viv’ atribuis <br/>
        Al vir’ la meriton ne cedi al plag’.
      </p>

      <p class="poem-block mb-3">
        Ni ĉiam kampiras, <br/>
        Sed dormi ne lasas nin sola afer’: <br/>
        Ni kien foriras, <br/>
        Dum regas plenpove sur Ter’ primaver’? <br/>
        Ni kial foriras, <br/>
        Dum regas plenpove sur Ter’ primaver’?
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kanzono pri infanterio'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['pMy2hXzwkAs'],
    itemTranslator: `
      Teksto kaj muziko: Bulat Okuĝava, <br/>
      ${translator.esp}
    `
  }
}

export default item;